import { tokens } from "styles/Tokens";
import Typography from "./Typography";

interface Props {
  type: any;
  name: string | undefined;
  message?: string;
}

function Validation(props: Props) {
  const { type, message } = props;

  const getErrorMessage = (type: string) => {
    if (type === "required") {
      return `Required`;
    }
    if (type === "min") {
      return `Invalid value`;
    }
    if (type === "max") {
      return `Maximum allowed value is 9999`;
    }

    return message;
  };

  return (
    <Typography variant={"label"} color={tokens.Text.Feedback.Alert}>
      {getErrorMessage(type)}
    </Typography>
  );
}

export default Validation;
